import { render, staticRenderFns } from "./ProjectInfo.vue?vue&type=template&id=1c0749ce&"
import script from "./ProjectInfo.vue?vue&type=script&lang=js&"
export * from "./ProjectInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProjectInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c0749ce')) {
      api.createRecord('1c0749ce', component.options)
    } else {
      api.reload('1c0749ce', component.options)
    }
    module.hot.accept("./ProjectInfo.vue?vue&type=template&id=1c0749ce&", function () {
      api.rerender('1c0749ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/workPermits/ProjectInfo.vue"
export default component.exports